import { useDispatch, useSelector } from 'react-redux';

import { useLocalFormState } from '../../hooks/useLocalFormState';
import { previousBookingLogin } from '../../redux/booking/previousBooking/actions';
import {
  getMyBookingErrorSelector,
  getMyBookingFailedSelector,
  getMyBookingSelector,
} from '../../redux/booking/previousBooking/selector';
import { removeSpaces, trimSpaces } from '../../utils/utils';
import { validateField } from './PreviousBookingLogin';

export const usePreviousBookingLoginActions = () => {
  const dispatch = useDispatch();

  return {
    previousBookingLogin: (bookingId, surname, postcode) => {
      return new Promise((resolve, reject) => {
        previousBookingLogin(dispatch, removeSpaces(bookingId), trimSpaces(surname), removeSpaces(postcode))
          .request // access the underlying promise
          .then(resolve)
          .catch(reject);
      });
    },
  };
};

export const usePreviousBookingLoginState = () => ({
  ...useLocalFormState(validateField),
  getMyBooking: useSelector(getMyBookingSelector),
  getMyBookingFailed: useSelector(getMyBookingFailedSelector),
  getMyBookingError: useSelector(getMyBookingErrorSelector),
});